"use strict";
import {http} from '../../core';
const RequestService = http.create();

export default {
    // 默认页查询所有文档
    // getList:function (params) {
    //     return RequestService.get("/mock/itsm/doc/list/all",params);
    // },
    // 获取文档目录
    getDirectoryList:function (params) {
        return RequestService.get("directory/list",params);
    },
    // 获取文档目录(不分页)
    getNoPageDirectoryList:function (params) {
        return RequestService.get("directory/list/all",params);
    },
    // 上传文件
    // getUploadMes:function (params) {
    //     return RequestService.post("fastdfs/v1/upload",params);
    // },
    // 新增文件
    addDoc:function (params) {
        return RequestService.post("doc/add",params);
    },
    // 更新文件
    updateDoc:function (params) {
        return RequestService.post("doc/update",params);
    },
    // 删除文件
    delDoc:function (params) {
        return RequestService.get("doc/del",params);
    },
    // 新增文档目录
    addDirectory:function (params) {
        return RequestService.post("directory/add",params);
    },
    // 更新文档目录
    updateDirectory:function (params) {
        return RequestService.post("directory/update",params);
    },
    // 删除文档目录
    delDirectory:function (params) {
        return RequestService.get("directory/del",params);
    },
    // 查询目录详情
    getDirectoryDetail:function (params) {
        return RequestService.get("directory/detail",params);
    },
    // 根据目录id-查询文件列表
    getDocById:function (params) {
        return RequestService.get("doc/list",params);
    },
    // 查询文档详情
    getDocDetail:function (params) {
        return RequestService.get("doc/detail",params);
    },
    // 搜索文件
    searchDoc:function (params) {
        return RequestService.post("doc/search",params);
    },
}